




































import Vue from "vue";

// Components
import MachineStatusPropsList from "@/components/PropsLists/MachineStatusPropsList.vue";
import DiagnosticImageCard from "@/views/App/Components/DiagnosticImageCard.vue";
import MaintenanceStatusText from "@/components/Maintenance/MaintenanceStatusText.vue";

// Model
import { Machine } from "@/model/data/Machine";
import { MachineStatus } from "@/model/data/status/MachineStatus";
import { GetErrorDetailsCommand, GetErrorDetailsReqData } from "@/model/communication/status/GetErrorDetailsCommand";
import { GetErrorDetailsResData } from "@/model/communication/status/GetErrorDetailsResData";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ClientUser } from "@/model/data/authentication/ClientUser";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { LicenseModuleEnum } from "@/model/data/License/LicenseModuleEnum";
import { LicenseData } from "@/model/data/License/LicenseData";
import { mapState } from "vuex";
import { RootState } from "@/store";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";

export default Vue.extend({
    components: {
        MachineStatusPropsList,
        MaintenanceStatusText,
        DiagnosticImageCard,
    },
    props: {
        machine: { type: Object as () => Machine, required: true },
        machineStatus: { type: Object as () => MachineStatus, required: true },
        hasAgent: Boolean,
    },
    data() {
        return {
            errorLabel: "",
            errorLabelLoading: false,
            CashTypeEnum,
            showImageDialog: false,
            serviceCounterSupportedModels: ["CIMA CV7000", "CLS"],
        };
    },
    watch: {
        "machineStatus.extension": {
            handler(extension) {
                if (extension && extension != "0" && !extension.includes("AREA")) this.getErrorDetails(this.machineStatus.extension);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        ...mapState({
            authUser: (state: RootState) => state.authMod.currentUser,
            licenseModules: (state: RootState) => state.license.licenseModules,
        }),
        showMaintenanceStatus() {
            let serviceCountSupported = false;
            if (this.machine && this.machine.recognitionSensorModel) {
                for (let supportedModels of this.serviceCounterSupportedModels) {
                    serviceCountSupported = this.machine.recognitionSensorModel.includes(supportedModels);
                    if (serviceCountSupported) break;
                }
            }
            return (
                (this.authUser as ClientUser).profile.privileges.and(ClientPrivileges.PreventiveMaintenanceStatus) == ClientPrivileges.PreventiveMaintenanceStatus &&
                (this.licenseModules as LicenseData).isAvailable(LicenseModuleEnum.PredictiveMaintenance) &&
                serviceCountSupported
            );
        },
    },
    methods: {
        async getErrorDetails(error: string) {
            try {
                this.errorLabelLoading = true;
                let reqData = new GetErrorDetailsReqData(this.machine.model, "0", "0", this.machine.supportedCashType, error);
                let response: GetErrorDetailsResData = await new GetErrorDetailsCommand(reqData).execute();
                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    if (error) this.errorLabel = error.trim();
                    if (response.caosErrorLabel != null && response.caosErrorLabel != undefined && response.caosErrorLabel != "") this.errorLabel += `: ${response.caosErrorLabel}`;
                }
            } catch (e) {
                this.errorLabel = error;
                console.log("Something went wrong sending GetErrorDetailsCommand request ", e);
            }
            this.errorLabelLoading = false;
        },
    },
});
